import {TitleCredit} from '@app/titles/models/title';
import {Trans} from '@common/i18n/trans';
import {SiteSectionHeading} from '@app/titles/site-section-heading';
import {Link} from 'react-router-dom';
import {ArrowForwardIcon} from '@common/icons/material/ArrowForward';
import {TitleCreditsGrid} from '@app/titles/pages/title-page/title-credits-grid/title-credits-grid';
import EmptyData from '../EmptyData';

interface Props {
  credits: TitleCredit[] | undefined;
}
export function TitlePageCast({credits = []}: Props) {
  const cast = credits.filter(credit => credit.pivot.department === 'actors');
  return (
    <div className="mt-48">
      <SiteSectionHeading isInTitle>
        <Trans message="Cast" />
      </SiteSectionHeading>
      {cast.length !== 0 ? (
        <>
          {' '}
          <TitleCreditsGrid credits={cast} />
          <Link
            to="full-credits"
            style={{
              backgroundColor: '#DC2626',
              color: '#FFFFFF',
              padding: '12px 24px',
              borderRadius: '8px',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              transition: 'all 0.3s ease',
              transform: 'scale(1)',
              width: 'max-content',
              margin: '16px auto',
            }}
            className="hover:scale-105 active:scale-95"
            onMouseOver={e => {
              e.currentTarget.style.backgroundColor = '#B91C1C'; // Darker red on hover
              e.currentTarget.style.boxShadow =
                '0 6px 12px rgba(0, 0, 0, 0.15)';
            }}
            onMouseOut={e => {
              e.currentTarget.style.backgroundColor = '#DC2626'; // Original red
              e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
            }}
            onMouseDown={e => {
              e.currentTarget.style.backgroundColor = '#991B1B'; // Even darker red on click
            }}
            onMouseUp={e => {
              e.currentTarget.style.backgroundColor = '#B91C1C'; // Revert to hover state
            }}
          >
            <ArrowForwardIcon />
            <Trans message="All cast and crew" />
          </Link>
        </>
      ) : (
        <EmptyData />
      )}
    </div>
  );
}
